const SCREEN_TRACKING = {
  HOME: {
    // JOIN: 'join',
    BUTTON: {
      MAIN_PAGE: 'button_home',
      JOIN: 'button_join',
    },
  },
  LOGIN: {
    BUTTON: {
      JOIN: 'button_join',
      SEND_OTP: 'send_otp',
      RESEND_OTP: 'button_resend',
      CONFIRM: 'button_confirm ',
    },
  },
  LOGIN_FIRST_LOGIN: {
    ID_BUTTON_UPDATE: '',
  },
  ADDRESS: {
    BUTTON: {
      DELIVERY: 'button_address',
      UPDATE: 'button_update',
    },
  },
  CAMERA: {
    BUTTON: {
      CAMERA: 'button_camera',
      INVOICE_CAPTURE: 'button_scanreceipt',
      CONFIRM: 'button_confirm',
      CANCEL: 'button_cancel',
      GUIDE: 'button_guide',
      CHECK_AGAIN: 'button_check',
      RETURN_HOME: 'button_home',
      COMPLETE: 'button_complete',
      SCAN_MORE: 'button_scanmore',
      CALL_ZALO: 'button_support_zalo',
      CALL_PHONE_NUMBER: 'button_support_phone',
      INVOICE_CAPTURE_AGAIN: 'button_rescan',
    },
  },
  PROFILE: {
    BUTTON: {
      UPDATE: 'button_update',
      PERSONAL_INFO: 'button_personal_info',
      PERSONAL: 'button_personal',
      RETURN_HOME: 'button_home',
    },
  },
  TOP_UP: {
    BUTTON: {
      RETURN: 'button_back',
      UPDATE: 'update',
      RECHARGING: 'button_topup',
      RETURN_HOME: 'button_home',
      CLOSE: 'CLOSE',
    },
  },
  GAME: {
    BUTTON: {
      GAME: 'button_game',
      RETURN_HOME: 'button_home',
    },
  },
  POLICY: {
    BUTTON: {
      RULE: 'button_rule',
    },
  },
  PHYSICAL_REWARD: {
    BUTTON: {
      RETURN: 'button_back',
    },
  },

  QA: {
    BUTTON: {
      QUESTION: 'button_question',
    },
  },
  MENU: {
    HOME: 'button_home',
    GIFT: 'button_gift',
    CAMERA: 'button_camera',
    GAME: 'button_game',
    SETTING: 'button_personal',
  },
  SUPPORT_CENTER: {
    BUTTON: {
      SUPPORT_CENTER: 'button_support',
      CALL_PHONE: 'button_support_phone',
      ZALO: 'button_support_zalo',
    },
  },
}
const LIST_NAME = [
  {
    id: 'button_join',
    name: 'Tham gia ngay',
  },
  {
    id: 'button_resend',
    name: 'Gửi lại mã OTP',
  },
  {
    id: 'button_address',
    name: 'Địa chỉ nhận hàng',
  },
  {
    id: 'button_scanmore',
    name: 'Chụp thêm',
  },
  {
    id: 'button_scanreceipt',
    name: 'Chụp hóa đơn',
  },
  {
    id: 'button_rescan',
    name: 'Chụp lại',
  },
  {
    id: 'button_confirm',
    name: 'Xác nhận',
  },
  {
    id: 'button_guide',
    name: 'Hướng dẫn chụp hóa đơn',
  },

  {
    id: 'button_cancel',
    name: 'Hủy',
  },

  {
    id: 'button_complete',
    name: 'Hoàn thành',
  },
  {
    id: 'button_check',
    name: 'Kiểm tra',
  },
  {
    id: 'invoice_capture',
    name: '',
  },
  {
    id: 'button_home',
    name: 'Trang chủ',
  },

  {
    id: 'button_personal',
    name: 'Cá nhân',
  },
  {
    id: 'button_personal_info',
    name: 'Thông tin cá nhân',
  },
  {
    id: 'button_topup',
    name: 'Nạp ngay',
  },
  {
    id: 'button_back',
    name: 'Trở về',
  },
  {
    id: 'button_home',
    name: 'Trang chủ',
  },
  {
    id: 'button_support_zalo',
    name: 'Nhắn tin hỗ trợ zalo',
  },
  {
    id: 'button_support_phone',
    name: 'Gọi hotline',
  },
  // {
  //   id: 'send_otp',
  //   name: 'Gửi mã xác nhận',
  // },
  // {
  //   id: 'button_update',
  //   name: 'Cập nhật',
  // },
  // {
  //   id: 'button_support_center',
  //   name: 'Liên hệ',
  // },

  {
    id: 'button_setting',
    name: '',
  },
  {
    id: 'button_support_phone',
    name: 'Gọi hotline',
  },

  {
    id: 'button_gift',
    name: 'Kho quà',
  },
  {
    id: 'button_rule',
    name: 'Thể lệ',
  },
  {
    id: 'button_question',
    name: 'Câu hỏi thường gặp',
  },
  {
    id: 'button_support',
    name: 'Hỗ trợ',
  },
  // {
  //   id: 'button_menu_home',
  //   name: 'Home',
  // },
  {
    id: 'button_camera',
    name: 'Camera',
  },
  {
    id: 'button_game',
    name: 'Game',
  },
  // {
  //   id: 'button_menu_setting',
  //   name: 'Setting',
  // },
]
const TRACKING_TYPE = {
  BUTTON_TRACKING: 'BUTTON_TRACKING',
  LOGIN_TRACKING: 'LOGIN_TRACKING',
  SET_USER_ID: 'SET_USER_ID',
  SET_APP_ID: 'SET_APP_ID',
  LOG_SIGN_UP: 'LOG_SIGN_UP',
  LOG_LOGIN: 'LOG_LOGIN',
  LOG_PAGEVIEW: 'LOG_PAGEVIEW',
}
export { SCREEN_TRACKING, LIST_NAME, TRACKING_TYPE }
